/* eslint-disable */
export default {
  toolTip: 'Weergeven in {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
